<template>
  <v-card height="100%" :flat="flat">
    <v-card-title class="font-weight-black">{{ $t('delivery.cart.products') }}</v-card-title>
    <v-card-text class="text-left">

      <template v-if="order.promos.length > 0">
        <h6 class="subtitle-1 grey--text text--darken-4 py-0">
          Promos
        </h6>
        <v-list class="px-0 pt-0" dense>
            <div v-for="orderPromo in order.promos" :key="orderPromo.id">
              <customer-cart-detail-promo
                  :order-promo="orderPromo"
                  :show-remove-button="false"
              ></customer-cart-detail-promo>
              <v-divider class="my-2"></v-divider>
            </div>
        </v-list>
      </template>

      <!--RENDER ITEMS GROUP BY CATEGORY-->
      <order-items md="12" :items="order.items"></order-items>
    </v-card-text>
<v-divider></v-divider>
    <v-card-title class="font-weight-black">{{ $t('delivery.cart.summary') }}</v-card-title>
    <v-card-text class="text-left">
      <cart-total
          :items-amount="order.itemsAmount + (order.promoAmount || 0)"
          :delivery-cost="order.delivery.cost"
          :delivery-free="order.deliveryFree"
          :discount-rate="order.discountRate"
          :total-discount="order.totalDiscount"
          :total-amount="order.totalAmount"
          :total-amount-with-discount="order.totalAmount"
      />

    <coupon-view :order="order"></coupon-view>

    </v-card-text>
  </v-card>

</template>

<script>
import OrderItems from "@/modules/delivery/components-core/shared/OrderItems/OrderItems.vue";
import CartTotal from "@/modules/delivery/components-core/shared/CartTotal/CartTotal.vue";
import CustomerCartDetailPromo
  from "@/modules/delivery/components-core/customer/CustomerCartDetail/CustomerCartDetailPromo.vue";
import CouponView from "@/modules/delivery/components/CouponView/CouponView.vue";

export default {
  name: "ShowOrderItems",
  components: {CouponView, CustomerCartDetailPromo, CartTotal, OrderItems},
  props: {
    order: {type: Object},
    flat: {type: Boolean, default: false}
  },
  computed:{

  }
}
</script>

<style scoped>

</style>
